import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CommonModal from "../../components/shared/modalLayout/CommonModal";
import { useGetAbnormalLensOrdersQuery } from "../../app/orderApi/OrderApi";
import { formatDashboardDateMedium } from "../../helpers/dashboardTime";

const formatDate = (value) => formatDashboardDateMedium(value, "");

const providerLabels = {
  ARTS: "Arts",
  PP: "PP",
  YUFENG: "Yufeng",
};

export default function AbnormalLensOrdersModal({ enabled }) {
  const [show, setShow] = useState(false);
  const { data, isSuccess } = useGetAbnormalLensOrdersQuery(undefined, {
    skip: !enabled,
  });
  const orders = data?.data?.orders || [];

  useEffect(() => {
    if (isSuccess && orders.length > 0) setShow(true);
  }, [isSuccess, orders.length]);

  return (
    <CommonModal
      show={show}
      setShow={setShow}
      className="abnormal-lens-orders-modal"
      centered
      title={`Abnormal lens orders <span class="status-badge log-badge ms-2">${orders.length}</span>`}
    >
      <p className="abnormal-lens-orders-copy">
        These lens orders have remained in status 3 for more than 9 days.
      </p>
      <div className="abnormal-lens-orders-list">
        {orders.map((order) => (
          <Link
            className="abnormal-lens-order"
            key={order.ItemID}
            to={`/orders/order-details/${encodeURIComponent(order.ShopifyId)}`}
            state={{ ItemID: order.ItemID }}
            onClick={() => setShow(false)}
          >
            <span className="abnormal-lens-order-main">
              <strong>Order {order.BackerID || "—"}</strong>
              <span>{order.ItemID}</span>
              <span>{order.customerName || "Unknown customer"}</span>
            </span>
            <span className="abnormal-lens-order-meta">
              <span className="abnormal-lens-provider">
                {providerLabels[order.provider] || "Unassigned"}
              </span>
              <strong>{order.daysPending} days</strong>
              <span>Since {formatDate(order.transitionedAt)}</span>
            </span>
          </Link>
        ))}
      </div>
    </CommonModal>
  );
}
